/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-10-18",
    versionChannel: "nightly",
    buildDate: "2024-10-18T00:06:13.525Z",
    commitHash: "5faa313a70d6ad47af18ad4b2f6517696118ef07",
};
